import { render, staticRenderFns } from "./document-request-row.vue?vue&type=template&id=6047f225"
import script from "./document-request-row.vue?vue&type=script&lang=js"
export * from "./document-request-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports